(function(){
  try {
    console.log('===> fw:数据采集开始!!!');
    const isMobile = window.innerWidth < 768;

    function sendData(data) {
      Shopify?.analytics?.publish("fw-video", {
        platform: !isMobile ? "pc" : "mobile",
        customerId: window.customer_id || "",
        ...data,
      });
    }

    function getVideoInfo (detail) {
      const video = detail?.video;
      return {
        caption: video?.caption,
        encoded_id: video?.encoded_id,
      };
    }

    function getProductInfo (detail) {
      const product = detail?.product;
      return {
        product_id: product?.product_ext_id,
        product_name: product?.product_name,
        product_handle: product?.product_handle,
      };
    }

    function getExtraInfo (detail) {
      return detail?.extra;;
    }

    document.addEventListener('fw:embed-feed:impression', function (event) {
      sendData({
        type: 'video-embed-impression',
        desc: '视频容器曝光',
      });
      console.log('===> fw:视频容器曝光，event:', event);
    });

    // 其实是视频播放时触发
    document.addEventListener('fw:video:impression', function (event) {
      const detail = event.detail;

      sendData({
        type: 'video-play-start',
        desc: '视频播放',
        video: getVideoInfo(detail),
        extra: getExtraInfo(detail),
      });
      console.log('===> fw:视频播放，event:', event);
    });

    document.addEventListener('fw:embed-feed:thumbnail-click', function (event) {
      const detail = event.detail;
      sendData({
        type: 'video-thumbnail-click',
        desc: '点击视频缩略图',
        video: getVideoInfo(detail),
      });
      console.log('===> fw:点击视频缩略图，event:', event);
    });

    // document.addEventListener('fw:video:start ', function (event) {

    //   console.log('===> fw:视频播放，event:', event);
    // });

    // document.addEventListener('fw:video:session', function (event) {
    //   console.log('===> fw:播放时长（看了几秒），event:', event);
    // });

    document.addEventListener('fw:video:interactable-engaged-view', function (event) {
      const detail = event.detail;

      sendData({
        type: 'video-play-3s',
        video: getVideoInfo(detail),
        extra: getExtraInfo(detail),
        desc: '3 秒完播率',
      });
      console.log('===> fw:3 秒完播率，event:', event);
    });

    document.addEventListener('fw:video:first-quartile', function (event) {
      const detail = event.detail;
      sendData({
        type: 'video-reached-25-percent',
        video: getVideoInfo(detail),
        extra: getExtraInfo(detail),
        desc: '视频播放到25%',
      });
    });

    document.addEventListener('fw:video:midpoint', function (event) {
      const detail = event.detail;
      sendData({
        type: 'video-reached-50-percent',
        video: getVideoInfo(detail),
        extra: getExtraInfo(detail),
        desc: '视频播放到50%',
      });
    });

    document.addEventListener('fw:video:third-quartile', function (event) {
      const detail = event.detail;
      sendData({
        type: 'video-reached-75-percent',
        video: getVideoInfo(detail),
        extra: getExtraInfo(detail),
        desc: '视频播放到75%',
      });
    });

    document.addEventListener('fw:video:complete', function (event) {
      const detail = event.detail;
      
      sendData({
        type: 'video-play-complete',
        video: getVideoInfo(detail),
        extra: getExtraInfo(detail),
        desc: '视频播放完成'
      });
      console.log('===> fw:视频完播，event:', event);
    });

    document.addEventListener('fw:shopping:product-card-impression', function (event) {
      const detail = event.detail;

      sendData({
        type: 'product-card-impression',
        product: getProductInfo(detail),
        extra: getExtraInfo(detail),
        video: getVideoInfo(detail),
        desc: '商品卡片曝光',
      });
      console.log('===> fw:商品卡片曝光，event:', event);
    });

    document.addEventListener('fw:shopping:product-card-clicked', function (event) {
      const detail = event.detail;
      
      sendData({
        type: 'product-card-click',
        product: getProductInfo(detail),
        extra: getExtraInfo(detail),
        video: getVideoInfo(detail),
        desc: '商品卡片点击',
      })
      console.log('===> fw:商品卡片点击，event:', event);
    });

    document.addEventListener('fw:shopping:pinned-product-clicked', function (event) {
      const detail = event.detail;
      
      sendData({
        type: 'product-click',
        product: getProductInfo(detail),
        extra: getExtraInfo(detail),
        video: getVideoInfo(detail),
        desc: '商品点击',
      });
      console.log("===> fw:商品点击，event:", event);
    });

    document.addEventListener('fw:shopping:pinned-product-impression', function (event) {
      const detail = event.detail;
      
      sendData({
        type: 'product-impression',
        product: getProductInfo(detail),
        extra: getExtraInfo(detail),
        video: getVideoInfo(detail),
        desc: '商品曝光',
      });
      console.log('===> fw:商品曝光，event:', event);
    });

    document.addEventListener('fw:shopping:request-checkout', function (event) {
      const detail = event.detail;
      const cart = detail?.cart;
      
      const cartItems = cart?.map?.(item => ({
        product_id: item?.product_id,
        product_name: item?.product_name,
        product_handle: item?.product_handle,
      })) || [];

      localStorage.setItem('fw:shopping:request-checkout', JSON.stringify(detail));

      sendData({
        type: 'checkout-click',
        video: getVideoInfo(detail),
        extra: getExtraInfo(detail),
        cart: cartItems,
        desc: 'click checkout',
      });
      console.log('===> fw:请求结算，event:', event);
    });

    document.addEventListener('fw:shopping:pdp-primary-cta-clicked', function (event) {
      const detail = event.detail;
      const type = detail?.type;

      if( type !== 'ADD TO CART' ) return;

      sendData({
        type: 'product-add-cart',
        product: getProductInfo(detail),
        extra: getExtraInfo(detail),
        video: getVideoInfo(detail),
        desc: '加入购物车',
      });
      console.log('===> fw:加入购物车，event:', event);
    });
  } catch (e) {
    console.error('===> fw:数据采集错误:', e);
  }
})()